import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { betCodeAPI } from '../api/endpoints';
import { formatTimeAgo, getStatusColor } from '../utils/helpers';
import { FaSearch, FaTicketAlt, FaUser, FaClock } from 'react-icons/fa';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './Search.css';

const Search = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (query) {
      performSearch(query);
    }
  }, [query]);

  const performSearch = async (searchQuery) => {
    setLoading(true);
    try {
      const response = await betCodeAPI.getList({ search: searchQuery, per_page: 50 });
      setResults(response.data.data || []);
      setTotal(response.data.total || 0);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="search-loading">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <div className="search-page">
      <div className="search-header">
        <h1>
          <FaSearch className="header-icon" /> Search Results
        </h1>
        {query && (
          <p className="search-query">
            Showing results for: <strong>"{query}"</strong>
          </p>
        )}
      </div>

      {results.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🔍</div>
          <h3>No results found</h3>
          <p>Try searching with different keywords</p>
        </div>
      ) : (
        <>
          <div className="results-info">
            Found {total} result{total !== 1 ? 's' : ''}
          </div>
          <div className="search-results">
            {results.map((bet) => (
              <Link to={`/bet-codes/${bet.id}`} key={bet.id} className="search-result-item">
                <div className="result-content">
                  <div className="result-header">
                    <span className="result-platform">{bet.platform || 'General'}</span>
                    <span 
                      className="result-status"
                      style={{ color: getStatusColor(bet.status) }}
                    >
                      {bet.status}
                    </span>
                    {bet.is_private && (
                      <span className="private-badge">🔒 Private</span>
                    )}
                  </div>
                  <h3 className="result-title">{bet.title}</h3>
                  <div className="result-code">{bet.code}</div>
                  <div className="result-footer">
                    <div className="result-author">
                      <FaUser className="footer-icon" />
                      <span>{bet.author}</span>
                    </div>
                    <div className="result-meta">
                      <span><FaTicketAlt /> {bet.number_of_games} games</span>
                      <span><FaClock /> {formatTimeAgo(bet.created_at)}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Search;